export const AVATAR_CHANGED = 'lureo:avatar-changed';

export function notifyAvatarChanged() {
  window.dispatchEvent(new Event(AVATAR_CHANGED));
}
